import React, {useState} from 'react';
import { Grid, Box, Typography, Button, CssBaseline, TextField, Link, Paper, Alert } from '@mui/material'
import {ThemeProvider } from '@mui/material/styles';
import logo from '../components/small_components/eternadna-logo.png'

function PasswordPage({theme, correctPassword, setIsloggedIn}) {

    const [error, setError] = useState(false)

    function handleSubmit(e) {
        let password = document.getElementById('password').value
        if (password == correctPassword) {
          setIsloggedIn(true);
        } else {
          setError(true)
        }
      }
    
      function Error() {
        if (error == true) {
          return (
            <Alert severity="error">Wrong password</Alert>
          )
        } else {
          return (
            <div></div>
          )
        }
      }

  return (
    <ThemeProvider theme={theme}>
    <Grid container component="main" sx={{ height: '100vh' }}>
      <CssBaseline />
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        sx={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1637404230552-5ac6d76cb3a0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1035&q=80)',
          backgroundRepeat: 'no-repeat',
          backgroundColor: (t) =>
            t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <img className="logo" src={logo} height="40" />
          <Typography component="h1" variant="h5" textAlign='center'>
            Hey There! Use the password sent to your email to access our questionnaire.
          </Typography>
          <Box noValidate component="form" onSubmit={handleSubmit}  sx={{ mt: 4 }}>
            <TextField
              margin="normal"
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <Error />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Submit
            </Button>
            <Grid container>
              <Grid item xs>
                <Link href="https://eterna-life.com/pages/contact" variant="body2">
                  Didn't receive a password? Chat with us!
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Grid>
    </Grid>
  </ThemeProvider>
  )
}

export default PasswordPage